import { alpha, Theme } from '@mui/material';

export default {
    tooltipContainer: {
        width: '280px',
    },
    sectionWrapper: {
        borderTop: '1px solid',
        borderColor: (theme: Theme) => alpha(theme.palette.text.primary, 0.08),
        p: 1,
        alignItems: 'flex-start',
        '&:first-of-type': {
            borderTop: 'none',
        },
    },
    iconHolder: {
        height: '16px',
        width: '16px',
        mr: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
    },
    fixedValueRow: {
        overflow: 'hidden',
        '.fixed-label': {
            width: '100px',
            flexShrink: 0,
            mr: 1,
        },
        '.fixed-value': {
            flexGrow: 1,
            overflow: 'hidden',
            wordWrap: 'break-word',
        },
    },
    breakWordValue: {
        wordWrap: 'break-word',
        overflow: 'hidden',
    },
};
